import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const BASE =
  "group inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold transition-all duration-300";

export function ButtonPrimary({ to, href, children, className = "", testid }) {
  const cls = `${BASE} bg-brand text-brand-foreground shadow-glow-sm hover:-translate-y-0.5 hover:bg-brand-strong ${className}`;
  const inner = (
    <>
      {children}
      <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
    </>
  );
  if (to)
    return (
      <Link to={to} className={cls} data-testid={testid}>
        {inner}
      </Link>
    );
  return (
    <a href={href} className={cls} data-testid={testid}>
      {inner}
    </a>
  );
}

export function ButtonSecondary({ to, href, children, className = "", testid }) {
  const cls = `${BASE} border border-border bg-card/60 text-foreground hover:-translate-y-0.5 hover:border-electric/50 hover:text-electric ${className}`;
  if (to)
    return (
      <Link to={to} className={cls} data-testid={testid}>
        {children}
      </Link>
    );
  return (
    <a href={href} className={cls} data-testid={testid}>
      {children}
    </a>
  );
}

export function ButtonGhostLight({ to, children, className = "", testid }) {
  const cls = `${BASE} border border-white/25 text-white hover:-translate-y-0.5 hover:bg-white/10 ${className}`;
  return (
    <Link to={to} className={cls} data-testid={testid}>
      {children}
    </Link>
  );
}
